"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addImageToAnswer = addImageToAnswer;
exports.removeImageFromAnswer = removeImageFromAnswer;
function addImageToAnswer(currentAnswer, newImage) {
  if (currentAnswer.files) {
    return {
      file: currentAnswer.file,
      files: currentAnswer.files.concat([newImage])
    };
  }
  if (currentAnswer.file) {
    return {
      file: currentAnswer.file,
      files: [currentAnswer.file, newImage]
    };
  }
  return {
    file: newImage,
    files: [newImage]
  };
}
function removeImageFromAnswer(currentAnswer, removedImageBlobId) {
  if (currentAnswer.files && currentAnswer.files.length > 1) {
    var files = currentAnswer.files.filter(function (file) {
      return file.blobId !== removedImageBlobId;
    });
    return {
      file: files[0],
      files: files
    };
  }
  return {};
}